import { BigNumber } from '@ethersproject/bignumber';
import { LTV } from 'app/features/util/ltv';
import { SiloAsset } from 'queries/decoratedSilo';
import { FC, useMemo } from 'react';
import { BaseHealthFactor } from './components';
import { GetNewLTV } from './types';
import { normalizeToPoints_LEGACY } from '@silo/utils';
import { StaticBar } from '@silo/ui';

export type StaticDualVariantProps = {
  variant: 'staticDual';
  normalizedTokenAmount: BigNumber | null;
  selectedAsset: SiloAsset;
  currentLTV: LTV;
  getNewLTV: GetNewLTV;
};

export const StaticDualVariant: FC<StaticDualVariantProps> = ({
  normalizedTokenAmount,
  selectedAsset,
  currentLTV,
  getNewLTV,
}) => {
  const newLTV = useMemo(() => {
    if (!normalizedTokenAmount) return currentLTV;

    return getNewLTV({
      currentLTV: currentLTV,
      normalizedTokenAmount,
      selectedAsset,
    });
  }, [normalizedTokenAmount, selectedAsset, currentLTV, getNewLTV]);

  const newPoints = normalizeToPoints_LEGACY(newLTV.healthFactor);
  const currentPoints = normalizeToPoints_LEGACY(currentLTV.healthFactor);

  return (
    <BaseHealthFactor
      displayPoints={newPoints}
      bar={<StaticBar includeNew currentPoints={currentPoints} newPoints={newPoints} />}
    />
  );
};
